import React, { FunctionComponent, useCallback, useContext, useMemo } from "react";
import { Grid, makeStyles, Theme } from "@material-ui/core";
import { MenuSubcategoryDictionary } from "../../../models/categories";
import { ExplanationWrapper } from "../explanation/explanation-wrapper";
import { PresentationWrapperFooter } from "./presentation-wrapper-footer";
import { NutritionContext } from "../context/nutrition-context";

const useStyles = makeStyles((theme: Theme) => ({
  hero: {
    width: "100%",
  },
}));

interface IPresentationWrapperProps {}

export const PresentationWrapper: FunctionComponent<IPresentationWrapperProps> = (props) => {
  const classes = useStyles();
  const { activeCategory, activeSubcategory, activeIndex: pageIndex, setActiveIndex } = useContext(NutritionContext);
  const activeIndex = pageIndex - 1;
  const selectedSubcategory = useMemo(() => MenuSubcategoryDictionary[activeSubcategory], [activeSubcategory]);

  const pages = useMemo(() => selectedSubcategory.pages || [], [selectedSubcategory]);

  const setPageIndex = useCallback(
    (p: number) => {
      const page = p + 1;
      const pageToApply = page >= pages.length ? pages.length : page < 1 ? 1 : page;
      setActiveIndex(pageToApply);
    },
    [pages, setActiveIndex],
  );

  const { hideFooter } = selectedSubcategory;

  const SubCategoryComponent = useMemo(() => pages[activeIndex], [activeIndex, pages]);
  return (
    <ExplanationWrapper
      activeIndex={activeIndex}
      pages={pages.length}
      setIndex={setPageIndex}
      onPrevious={() => setPageIndex(activeIndex - 1)}
    >
      <Grid container>
        <Grid item container direction="row" className={classes.hero}>
          <SubCategoryComponent />
        </Grid>
        {!hideFooter && (
          <PresentationWrapperFooter
            activeCategory={activeCategory}
            activeIndex={activeIndex}
            pages={pages.length}
            setPageIndex={setPageIndex}
          />
        )}
      </Grid>
    </ExplanationWrapper>
  );
};
